import request from '@/utils/request'

export function getTree(data) {
  return request({
    url: 'tenant/getTree',
    method: 'post',
    data
  })
}
export function save(data) {
  return request({
    url: 'tenant/save',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'tenant/delete',
    method: 'post',
    data
  })
}

export function getAll(data) {
  return request({
    url: 'tenant/getAll',
    method: 'post',
    data
  })
}

export function getToken(data) {
  return request({
    url: 'tenant/getToken',
    method: 'post',
    data
  })
}

export function refreshToken(data) {
  return request({
    url: 'tenant/refreshToken',
    method: 'post',
    data
  })
}



